import { bootstrapApplication } from '@angular/platform-browser';
import { InjectionToken } from '@angular/core';

import { appConfig } from './app/app.config';
import { App } from './app/app';



import { initializeApp } from 'firebase/app';
import { getFirestore, type Firestore } from 'firebase/firestore';
import { getStorage, type FirebaseStorage } from 'firebase/storage';
import { getAuth, type Auth } from 'firebase/auth';
import { getFunctions, type Functions } from 'firebase/functions';
import { environment } from './environment/environment';

// 1) Firebase één keer initialiseren
export const firebaseApp = initializeApp(environment.firebase);

// 2) Firestore instantie
export const db = getFirestore(firebaseApp);

// 3) Storage instantie
export const storage = getStorage(firebaseApp);

// 4) Auth instantie
export const auth = getAuth(firebaseApp);

// 5) Functions instantie (us-central1 is de default regio voor Firebase Functions)
export const functions = getFunctions(firebaseApp);

// 6) DI-tokens zodat je Firebase services kan injecteren
export const FIRESTORE = new InjectionToken<Firestore>('FIRESTORE');
export const STORAGE = new InjectionToken<FirebaseStorage>('STORAGE');
export const AUTH = new InjectionToken<Auth>('AUTH');
export const FUNCTIONS = new InjectionToken<Functions>('FUNCTIONS');

bootstrapApplication(App, {
  ...appConfig,
  providers: [
    ...(appConfig.providers ?? []),
    { provide: FIRESTORE, useValue: db },
    { provide: STORAGE, useValue: storage },
    { provide: AUTH, useValue: auth },
    { provide: FUNCTIONS, useValue: functions },
  ],
}).catch((err) => console.error(err));
